import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_CASH_REGISTER_VOUCHER_BALANCE } from '../main.api';
import { ValueCardBalance } from '../types/value-card-balance';

@Injectable()
export class ValueCardRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async valueCardBalance(valueCardNumber: string): Promise<ValueCardBalance> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_CASH_REGISTER_VOUCHER_BALANCE,
      pathParams: { voucher: valueCardNumber },
    });
  }
}
